export const BUCKET_MIN_LENGTH = 3;
// 63 is a hard limit in AWS
export const BUCKET_MAX_LENGTH = 63;
export const FILESPACE_NAME_MIN_LENGTH = 2;
// 63 is a hard limit in AWS
export const FILESPACE_NAME_MAX_LENGTH = 30;
export const REGION_NAME_MIN_LENGTH = 2;
export const BUCKET_NAME_START_WITH_REGEX = /^[\da-z].*$/;
export const BUCKET_NAME_ENDS_WITH_REGEX = /^.*[\da-z]$/;
export const BUCKET_NAME_CONTENT_REGEX = /^[\d.a-z-]*$/;
export const BUCKET_NAME_DASHES_REGEX = /^[^-]*(?:-[^-]+)*$/;
export const REGION_NAME_START_WITH_REGEX = /^[\dA-Za-z].*$/;
export const REGION_NAME_ENDS_WITH_REGEX = /^.*[\dA-Za-z]$/;
export const REGION_NAME_CONTENT_REGEX = /^[\dA-Za-z-]*$/;
export var FilespaceFormat;
(function (FilespaceFormat) {
    FilespaceFormat["V1_0"] = "1.0";
    FilespaceFormat["V2_0"] = "2.0";
    FilespaceFormat["V2_2"] = "2.2";
    FilespaceFormat["V3_0"] = "3.0";
    FilespaceFormat["V3_3"] = "3.3";
    FilespaceFormat["V3_5"] = "3.5";
    FilespaceFormat["V3_6"] = "3.6";
    FilespaceFormat["V3_8"] = "3.8";
    FilespaceFormat["V3_9"] = "3.9";
})(FilespaceFormat || (FilespaceFormat = {}));
export const FilespaceFormatCurrent = FilespaceFormat.V3_8;
// increase only when we support the format for filespace migrations (classic & layout)
export const FilespaceFormatForMigrations = FilespaceFormat.V3_8;
export const FilespaceVersion = {
    V3: 3,
    V4: 4,
    V6: 6,
    V7: 7,
    V8: 8,
    V9: 9,
    V10: 10,
    V12: 12,
    V13: 13,
};
export const FilespaceVersionValues = Object.values(FilespaceVersion);
export const FilespaceFormatToVersionMap = {
    [FilespaceFormat.V1_0]: FilespaceVersion.V3,
    [FilespaceFormat.V2_0]: FilespaceVersion.V4,
    [FilespaceFormat.V2_2]: FilespaceVersion.V6,
    [FilespaceFormat.V3_0]: FilespaceVersion.V7,
    [FilespaceFormat.V3_3]: FilespaceVersion.V8,
    [FilespaceFormat.V3_5]: FilespaceVersion.V9,
    [FilespaceFormat.V3_6]: FilespaceVersion.V10,
    [FilespaceFormat.V3_8]: FilespaceVersion.V12,
    [FilespaceFormat.V3_9]: FilespaceVersion.V13,
};
export const FilespaceVersionToFormatMap = {
    [FilespaceVersion.V3]: FilespaceFormat.V1_0,
    [FilespaceVersion.V4]: FilespaceFormat.V2_0,
    [FilespaceVersion.V6]: FilespaceFormat.V2_2,
    [FilespaceVersion.V7]: FilespaceFormat.V3_0,
    [FilespaceVersion.V8]: FilespaceFormat.V3_3,
    [FilespaceVersion.V9]: FilespaceFormat.V3_5,
    [FilespaceVersion.V10]: FilespaceFormat.V3_6,
    [FilespaceVersion.V12]: FilespaceFormat.V3_8,
    [FilespaceVersion.V13]: FilespaceFormat.V3_9,
};
export const mapFilespaceFormatToVersion = (filespaceFormat) => {
    const version = FilespaceFormatToVersionMap[filespaceFormat];
    if (!version) {
        throw new Error(`Cannot find the filespace version for format ${filespaceFormat}`);
    }
    return version;
};
export const mapFilespaceVersionToFormat = (filespaceVersion) => {
    const format = FilespaceVersionToFormatMap[filespaceVersion];
    if (!format) {
        throw new Error(`Cannot find the filespace format for version ${filespaceVersion}`);
    }
    return format;
};
export var StorageOwner;
(function (StorageOwner) {
    StorageOwner["ANY"] = "any";
    StorageOwner["LUCIDLINK"] = "lucidlink";
    StorageOwner["CUSTOMER"] = "customer";
})(StorageOwner || (StorageOwner = {}));
export const StorageCredentialsType = {
    ACCESS_KEY: 'accessKey',
    ROLE: 'role',
};
export var AllowedStorageType;
(function (AllowedStorageType) {
    AllowedStorageType["LUCIDLINK"] = "lucidlink";
    AllowedStorageType["CUSTOM"] = "custom";
})(AllowedStorageType || (AllowedStorageType = {}));
export const STORAGE_PROVIDER_OTHER = 'Other';
export { NAME_CONTENT_REGEX as FILESPACE_NAME_CONTENT_REGEX, NAME_END_REGEX as FILESPACE_NAME_END_REGEX, NAME_OPENAPI_REGEX as FILESPACE_NAME_OPENAPI_REGEX, NAME_START_REGEX as FILESPACE_NAME_START_REGEX, } from '#validation/common/constants';
export var FilespaceStatus;
(function (FilespaceStatus) {
    FilespaceStatus["READY"] = "ready";
    FilespaceStatus["SETUP_IN_PROGRESS"] = "setupInProgress";
    FilespaceStatus["SETUP_ERROR"] = "setupError";
    FilespaceStatus["SUSPEND_IN_PROGRESS"] = "suspendInProgress";
    FilespaceStatus["SUSPEND_ERROR"] = "suspendError";
    FilespaceStatus["SUSPENDED"] = "suspended";
    FilespaceStatus["UNSUSPEND_IN_PROGRESS"] = "unsuspendInProgress";
    FilespaceStatus["UNSUSPEND_ERROR"] = "unsuspendError";
    FilespaceStatus["ERRORED"] = "errored";
})(FilespaceStatus || (FilespaceStatus = {}));
